class InlineQuickAddTrigger extends HTMLButtonElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {

    const hash = this.dataset.inlineQuickAddHash;

    this.dispatchEvent(new CustomEvent('inline-quick-add:open', {
      bubbles: true,
      composed: true,
      detail: {
        hash,
      },
    }));
  }
}

customElements.define('inline-quick-add-trigger', InlineQuickAddTrigger, { extends: 'button' });
